import * as Types from '../../../../__generated__/schema';

import {
  ActorTeaserAPIToken,
  ActorTeaserUser,
} from '../../../graphql/fragments/ActorTeaser.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import { ActorTeaser } from '../../../graphql/fragments/ActorTeaser.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RunAiAuthorRunbookVariables = Types.Exact<{
  input: Types.AIAuthorRunbookInput;
}>;

export type RunAiAuthorRunbook = {
  aiAuthorRunbook: Pick<
    Types.AIInferenceStream,
    'streamName' | 'streamId' | 'pinned' | 'saved' | 'createdAt' | 'parentStreamId'
  > & { createdBy?: Types.Maybe<ActorTeaserAPIToken | ActorTeaserUser> };
};

export const RunAiAuthorRunbookDocument = gql`
  mutation RunAiAuthorRunbook($input: AIAuthorRunbookInput!) {
    aiAuthorRunbook(input: $input) {
      streamName
      streamId
      pinned
      saved
      createdBy {
        ...ActorTeaser
      }
      createdAt
      parentStreamId
    }
  }
  ${ActorTeaser}
`;
export type RunAiAuthorRunbookMutationFn = Apollo.MutationFunction<
  RunAiAuthorRunbook,
  RunAiAuthorRunbookVariables
>;

/**
 * __useRunAiAuthorRunbook__
 *
 * To run a mutation, you first call `useRunAiAuthorRunbook` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunAiAuthorRunbook` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runAiAuthorRunbook, { data, loading, error }] = useRunAiAuthorRunbook({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRunAiAuthorRunbook(
  baseOptions?: Apollo.MutationHookOptions<RunAiAuthorRunbook, RunAiAuthorRunbookVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RunAiAuthorRunbook, RunAiAuthorRunbookVariables>(
    RunAiAuthorRunbookDocument,
    options,
  );
}
export type RunAiAuthorRunbookHookResult = ReturnType<typeof useRunAiAuthorRunbook>;
export type RunAiAuthorRunbookMutationResult = Apollo.MutationResult<RunAiAuthorRunbook>;
export type RunAiAuthorRunbookMutationOptions = Apollo.BaseMutationOptions<
  RunAiAuthorRunbook,
  RunAiAuthorRunbookVariables
>;
export function mockRunAiAuthorRunbook({
  data,
  variables,
  errors,
}: {
  data: RunAiAuthorRunbook;
  variables?: RunAiAuthorRunbookVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: RunAiAuthorRunbookDocument, variables },
    result: { data, errors },
  };
}
